/** @format */

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
function responseRejected(error: any) {
    // Get the first validation message for each form field
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
    if (error?.response?.data?.data?.errors) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        error.validationErrors = {};
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        Object.keys(error.response.data.data.errors).map((fieldName) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
            error.validationErrors[fieldName] =
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
                error.response.data.data.errors[fieldName][0];
        });
    }
    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- Legacy code: do not use as an example.
    return Promise.reject(error);
}

export const validationMessagesInterceptor = {
    responseRejected,
};
